<template>
  <div id="app">
    <div id="nav">
     <router-view></router-view>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'app'
  }
</script>
<style src="./assets/tailwind.css">
